import systemCompany from "./modules/systemCompany";
import systemUser from "./modules/systemUser";

export default {
  systemCompany,
  systemUser
}



// WEBPACK FOOTER //
// ./src/store/system/index.js